import React from 'react';

interface PropTypes {
  children: React.ReactNode;
}

function WarningContainer({ children }: PropTypes) {
  return (
    <div className="flex flex-col justify-center items-center w-full h-[calc(100vh-120px)] md:h-[calc(100vh-64px)]">
      {children}
    </div>
  );
}

export default WarningContainer;
